import { useMemo } from 'react';
import { NavLink, useLocation } from 'react-router';

import { useFlags } from '../../hooks';

import { DOWNBAR_FEATURE_FLAGS, MENU_LIST } from './Downbar.constants';
import { DownBarItem } from './Downbar.types';

import styles from './Downbar.module.scss';

const renderImage = (item: DownBarItem, isActive: boolean) =>
  (isActive ? item.activeImg : item.img);

const Downbar = () => {
  const location = useLocation();
  const menuFlags = useFlags(DOWNBAR_FEATURE_FLAGS);
  const menuList = useMemo(
    () => MENU_LIST.filter(item => (
      (!item.featureFlag || menuFlags[item.featureFlag].enabled)
      && (!item.hiddenByFeatureFlag || !menuFlags[item.hiddenByFeatureFlag].enabled)
    )),
    [menuFlags],
  );

  const isActiveBtn = (item: DownBarItem): boolean => location.pathname === item.path;

  const options = () =>
    menuList.map((item: DownBarItem) => {
      return (
        <button
          type="button"
          className={location.pathname === item.path ? styles.activeButton : styles.button}
          key={item.id}
        >
          <NavLink
            id={item.id}
            key={item.id}
            to={item.path}
            state={{
              isClickedBtnSidebar: true,
            }}
            style={{ textDecoration: 'none' }}
          >
            <div className={styles.image}>{renderImage(item, isActiveBtn(item))}</div>
            <div className={location.pathname === item.path ? styles.activeLabel : styles.label}>
              {item.label}
            </div>
          </NavLink>
        </button>
      );
    });

  return (
    <div className={styles.Wrapper}>
      <div className={styles.buttonsWrapper}>{options()}</div>
    </div>
  );
};

export default Downbar;
